<template>
  <RouterView />
</template>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--va-background-primary);
  color: var(--va-text-primary);
  min-height: 100vh;
}

body {
  margin: 0;
  min-width: 20rem;
  background-color: var(--va-background-primary);
  color: var(--va-text-primary);
}

html {
  background-color: var(--va-background-primary);
  color: var(--va-text-primary);
}
</style>
